<div class="summary-order-doctor-data-container">
    <div class="title-section" [ngClass]="{'skeleton-item background-grey': initialLoading}">
        <img src="https://s3.amazonaws.com/docs.public/images/iconos/pdf/Estetoscopio.svg" />
        <span> {{ 'shared.medicalOrder.summary.healthcareProfesionalTitle' | translate:locale.language }} </span>
    </div>
    <div class="nb_responsable_servicio">
        <div [ngClass]="{'skeleton-item background-grey': initialLoading}">{{publicProfile?.nombrePersona}}</div>
        <img
            class="profesional-verificado"
            *ngIf="!initialLoading && esProfesionalVerificado"
            src="https://s3.amazonaws.com/docs.public/images/iconos/Frame.png"
        />
    </div>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{publicProfile?.especialidad || 'N/A'}}
    </span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{empresaPortal?.denominacion || ''}}
    </span>
    <span class="truncate" [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{empresaPortal?.direccionLaboral || ''}} {{empresaPortal?.nombreCanonicoDivisionTerritorialLaboral || ''}}
    </span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{empresaPortal?.numeroTelCelular || 'N/A'}}<span *ngIf="empresaPortal?.numeroTelParticular">, {{empresaPortal?.numeroTelParticular || ''}}</span>
    </span>
    <span [ngClass]="{'skeleton-item background-grey': initialLoading}">
        {{empresaPortal?.emailLaboral || empresaPortal?.emailParticular || 'N/A'}}
    </span>
</div>